module.exports = __webpack_public_path__ + "static/media/paymentWaiver.7a4a0020.svg";